/** t622u: "Scheduled messages" in the chat sidebar, only while you have some waiting to send (no count badge). */
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { Clock } from 'lucide-react';
import { useWorkspaceId } from '@/lib/hooks';
import { useMyScheduled } from './scheduledQueries';

export function SidebarScheduledLink() {
  const q = useMyScheduled(useWorkspaceId());
  if (!(q.data ?? []).some(s => s.status === 'scheduled' || s.status === 'failed')) return null;
  return (
    <div><NavLink to="/chat/scheduled" data-testid="sidebar-scheduled" className={p => clsx('mx-2 flex items-center gap-2 rounded-md py-1 pl-6 pr-2 text-[13px]', p.isActive ? 'bg-sidebar-active text-white' : 'text-sidebar-muted hover:bg-sidebar-hover hover:text-white')}>
      <Clock className="h-3.5 w-3.5" />Scheduled messages</NavLink></div>
  );
}
